<template>
  <v-row>
    <v-col cols="12" sm="6" md="3" class="mb-3">
      <v-text-field
        :label="$t('users.search.form.first-name')"
        v-model.trim="searchParams.firstName"
        hide-details="auto"
        filled
        type="text"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="3" class="mb-3">
      <v-text-field
        :label="$t('users.search.form.last-name')"
        v-model.trim="searchParams.lastName"
        hide-details="auto"
        filled
        type="text"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="3" class="mb-3">
      <v-text-field
        :label="$t('users.search.form.email-address')"
        v-model.trim="searchParams.emailAddress"
        hide-details="auto"
        filled
        type="text"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="3" class="mb-3">
      <v-text-field
        :label="$t('users.search.form.phone-number')"
        v-model.trim="searchParams.phoneNumber"
        hide-details="auto"
        filled
        type="text"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-autocomplete
        filled
        v-model="searchParams.roleId"
        :items="roles"
        item-text="displayName"
        item-value="id"
        hide-details="auto"
        clearable
        :label="$t('users.search.form.role')"
      ></v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-autocomplete
        filled
        v-model="searchParams.advisorId"
        :items="advisors"
        item-text="displayText"
        item-value="value"
        hide-details="auto"
        clearable
        :label="$t('users.search.form.advisor')"
      ></v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-autocomplete
        filled
        v-model="searchParams.departmentId"
        hide-details="auto"
        :items="departments"
        item-text="displayText"
        item-value="value"
        clearable
        :label="$t('users.search.form.department')"
      ></v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-radio-group
        row
        filled
        v-model="searchParams.isActive"
        hide-details="auto"
        class="mt-0"
      >
        <v-radio
          :label="$t('users.search.form.status.active')"
          :value="true"
        ></v-radio>
        <v-radio
          :label="$t('users.search.form.status.inactive')"
          :value="false"
        ></v-radio>
        <v-radio
          :label="$t('users.search.form.status.all')"
          :value="null"
        ></v-radio>
      </v-radio-group>
    </v-col>
    <v-col
      v-if="isAdvisor"
      cols="12"
      sm="6"
      md="4"
      class="mb-3"
      align-self="center"
    >
      <v-checkbox
        class="mt-0"
        v-model="searchParams.invitedByMe"
        :label="$t('users.search.form.invitedByMe')"
        filled
        hide-details="auto"
      ></v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import authorizationUtils from "@/utils/authorization.js";

export default {
  props: {
    roles: {
      type: Array,
      default: () => [],
    },
    advisors: {
      type: Array,
      default: () => [],
    },
    departments: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    searchParams: {
      handler() {
        this.setSearchParams(this.searchParams);
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      searchParams: "SearchParams/getSearchParams",
    }),
    isAdvisor() {
      return authorizationUtils.isAdvisor();
    },
  },
  methods: {
    ...mapActions({
      setSearchParams: "SearchParams/setSearchParams",
    }),
  },
};
</script>
